import { signOut, type Me } from "./session";

// The ticket's literal ask: "the SPA shows an 'admins only' state" for a
// signed-in *non*-admin — distinct from SignInScreen's signed-out state.
// This is a UX nicety only: the real enforcement is server-side
// (`BffAuth.AdminPolicy`/`RequireRole("admin")` on `/api/admin/*`), so this
// screen existing or not changes nothing about what a non-admin can
// actually reach.
export function AdminsOnlyScreen({ me }: { me: Me }) {
  return (
    <div className="page">
      <header className="site-header">
        <div className="site-header-text">
          <h1>Admin</h1>
          <p className="tagline">Manage the store — catalog, inventory, orders, users.</p>
        </div>
      </header>

      <main>
        <section className="signin">
          <h2>Admins only</h2>
          <p>
            You're signed in as <strong>{me.name || me.email || me.sub}</strong>, but
            this area is for admins only. Sign out and sign back in with an account
            that has the <code>admin</code> role (the seeded{" "}
            <code>demo-admin@example.com</code>, for this demo) if you need access.
          </p>
          <button type="button" className="signin-button" onClick={() => signOut("/")}>
            Sign out
          </button>
        </section>
      </main>
    </div>
  );
}
